"use strict";

exports.__esModule = true;
exports.useIsomorphicLayoutEffect = exports.useWhyDidYouUpdate = exports.getOffsetTopRelativeToParent = exports.getScrollParent = exports.isBrowser = exports.getMaxContentWidthFromTheme = exports.numberToLetters = exports.formatSecondsToString = exports.transformDeprecatedContent = exports.transformDeprecatedWidget = exports.urlToFilter = exports.filterToUrl = exports.__ = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var smarttagsToUrl_1 = tslib_1.__importDefault(require("tagmanager-connector/lib/smarttagsToUrl"));

var urlToSmarttags_1 = tslib_1.__importDefault(require("tagmanager-connector/lib/urlToSmarttags"));

exports.__ = function (toTranslate) {
  return toTranslate;
};

var FILTER_ROWS_DELIMITER = ';|;';

function filterToUrl(filter) {
  var valueByName = filter.reduce(function (acc, f) {
    if (f.type === 'section') {
      var key = f.type;
      acc[key] = "" + (acc[key] ? "" + acc[key] + FILTER_ROWS_DELIMITER : '') + f.value;
    } else if (f.type === 'smarttag') {
      var key = "" + f.type + (f.subtype === 'excludes' ? '_exclude' : '');
      acc[key] = "" + (acc[key] ? "" + acc[key] + FILTER_ROWS_DELIMITER : '') + smarttagsToUrl_1["default"](f.value);
    } else {
      acc[f.type] = String(f.value);
    }

    return acc;
  }, {});
  return Object.entries(valueByName).map(function (_a) {
    var name = _a[0],
        value = _a[1];
    return name + "=" + encodeURIComponent(value);
  }).join('&');
}

exports.filterToUrl = filterToUrl;

function urlToFilter(url) {
  if (!url || url.length === 0) {
    return [];
  }

  return url.split('&').reduce(function (acc, part) {
    var _a = part.split('='),
        type = _a[0],
        encodedValue = _a[1];

    var value = decodeURIComponent(encodedValue);

    switch (type) {
      case 'doctype':
        acc.push({
          type: type,
          value: value.split(',')
        });
        break;

      case 'limit':
        acc.push({
          type: type,
          value: value
        });
        break;

      case 'parentSection':
        acc.push({
          type: type,
          value: value.split(',')
        });
        break;

      case 'siblingSections':
        acc.push({
          type: type,
          value: value.split(',')
        });
        break;

      case 'section':
        {
          var rows = value.split(FILTER_ROWS_DELIMITER);
          rows.forEach(function (row) {
            acc.push({
              type: type,
              value: row.length ? row.split(',') : []
            });
          });
          break;
        }

      case 'smarttag':
        {
          var rows = value.split(FILTER_ROWS_DELIMITER);
          rows.forEach(function (row) {
            acc.push({
              type: type,
              subtype: 'includes',
              value: row.length ? urlToSmarttags_1["default"](row) : []
            });
          });
          break;
        }

      case 'smarttag_exclude':
        {
          var rows = value.split(FILTER_ROWS_DELIMITER);
          rows.forEach(function (row) {
            acc.push({
              type: 'smarttag',
              subtype: 'excludes',
              value: row.length ? urlToSmarttags_1["default"](row) : []
            });
          });
          break;
        }

      case 'article':
        acc.push({
          type: type,
          value: value.split(',').map(Number)
        });
        break;

      case 'calendar':
        acc.push({
          type: type,
          value: value.split(',')
        });
        break;

      case 'dateFrom':
        acc.push({
          type: type,
          value: value
        });
        break;

      case 'dateTo':
        acc.push({
          type: type,
          value: value
        });
        break;

      default:
        break;
    }

    return acc;
  }, []);
}

exports.urlToFilter = urlToFilter;

function transformDeprecatedWidget(widget) {
  if (widget.type === 'fb') {
    var type = widget.type,
        config = tslib_1.__rest(widget, ["type"]);

    return {
      type: 'social',
      subtype: 'facebookpage',
      config: config
    };
  }

  return widget;
}

exports.transformDeprecatedWidget = transformDeprecatedWidget;

function transformDeprecatedContent(content) {
  return content.map(transformDeprecatedWidget);
}

exports.transformDeprecatedContent = transformDeprecatedContent;

exports.formatSecondsToString = function (seconds) {
  var m = String(Math.floor(seconds / 60)).padStart(2, '0');
  var rest = seconds % 60;
  var s = String(Math.round(rest * 100) / 100).padStart(2, '0');
  var secondsSplit = s.split('.');

  if (secondsSplit.length === 2) {
    s = (secondsSplit[0].length < 2 ? "0" + secondsSplit[0] : secondsSplit[0]) + "." + (secondsSplit[1].length < 2 ? secondsSplit[1] + "0" : secondsSplit[1]);
  }

  return m + ":" + s;
};

function numberToLetters(n) {
  var num = n;
  var a;
  var b;
  var ret = ''; // tslint:disable-next-line:no-conditional-assignment

  for (ret = '', a = 1, b = 26; (num -= a) >= 0; a = b, b *= 26) {
    ret = String.fromCharCode(parseInt(String(num % b / a), 10) + 97) + ret;
  }

  return ret;
}

exports.numberToLetters = numberToLetters;

exports.getMaxContentWidthFromTheme = function (theme) {
  var _a, _b;

  return (((_a = theme === null || theme === void 0 ? void 0 : theme.app) === null || _a === void 0 ? void 0 : _a.maxWidth) || 0) - (((_b = theme === null || theme === void 0 ? void 0 : theme.app) === null || _b === void 0 ? void 0 : _b.padding) || 0) * 2;
};

exports.isBrowser = function () {
  return typeof window !== 'undefined' && typeof window.location !== 'undefined' && typeof window.document !== 'undefined';
};

function getScrollParent(node) {
  if (!node) {
    return document.documentElement;
  }

  var overflowY = node instanceof HTMLElement && window.getComputedStyle(node).overflowY || '';
  var isScrollable = !(overflowY.includes('hidden') || overflowY.includes('visible'));

  if (isScrollable && node.scrollHeight >= node.clientHeight) {
    return node;
  }

  return getScrollParent(node.parentNode);
}

exports.getScrollParent = getScrollParent;

function getOffsetTopRelativeToParent(node, parent) {
  var element = node;
  var offsetTop = 0;

  while (element && element !== parent) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }

  return offsetTop;
}

exports.getOffsetTopRelativeToParent = getOffsetTopRelativeToParent;

function useWhyDidYouUpdate(name, props) {
  // Get a mutable ref object where we can store props ...
  // ... for comparison next time this hook runs.
  var previousProps = react_1["default"].useRef();
  react_1["default"].useEffect(function () {
    if (previousProps.current) {
      // Get all keys from previous and current props
      var allKeys = Object.keys(tslib_1.__assign(tslib_1.__assign({}, previousProps.current), props)); // Use this object to keep track of changed props

      var changesObj_1 = {}; // Iterate through keys

      allKeys.forEach(function (key) {
        // If previous is different from current
        if (previousProps.current[key] !== props[key]) {
          // Add to changesObj
          changesObj_1[key] = {
            from: previousProps.current[key],
            to: props[key]
          };
        }
      }); // If changesObj not empty then output to console

      if (Object.keys(changesObj_1).length) {
        console.log('[why-did-you-update]', name, changesObj_1); // tslint:disable-line:no-console
      }
    } // Finally update previousProps with current props for next hook call


    previousProps.current = props;
  });
}

exports.useWhyDidYouUpdate = useWhyDidYouUpdate;
exports.useIsomorphicLayoutEffect = exports.isBrowser() ? react_1["default"].useLayoutEffect : react_1["default"].useEffect;